import {CheckInEventType, CheckInSourceType} from '@lib/infrastructure';
import {checkInStatusesAdapter} from './adapters';
import {CheckInState, CheckInStatusesState} from './types';

export const getInitialState = (): CheckInState => ({
  status: {
    id: undefined,
    userId: undefined,
    directoryObjectId: '',
    eventType: CheckInEventType.NotCheckedInYet,
    buildingId: undefined,
    sourceType: CheckInSourceType.Manual,
  },
  isLoadingUserCheckIn: false,
  isLoadingConnectionsCheckIn: false,
  shouldCheckInAfterWorkspaceReservation: false,
  connectionsCheckInStatus: <CheckInStatusesState>checkInStatusesAdapter.getInitialState(),
  isCheckInBottomSheetVisible: false,
});
